export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_05_end.0568540a.jpg";